import { ServersService } from '@affine/core/modules/cloud';
import { WorkspacesService } from '@affine/core/modules/workspace';
import { useLiveData, useService } from '@toeverything/infra';
import { type PropsWithChildren, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { setGuestMode, useGuestMode } from './guest-mode';

export const SignInGate = ({ children }: PropsWithChildren) => {
  const serversService = useService(ServersService);
  const workspacesService = useService(WorkspacesService);
  const accounts = useLiveData(serversService.serversWithAccount$);
  const workspaces = useLiveData(workspacesService.list.workspaces$);
  const guestMode = useGuestMode();
  const location = useLocation();
  const signedIn = accounts.some(({ account }) => !!account);

  useEffect(() => {
    if (signedIn) setGuestMode(false);
  }, [signedIn, guestMode]);

  // Public documents, legal pages, invitations and auth callbacks stay reachable.
  const isKnownWorkspace = workspaces.some(
    workspace =>
      location.pathname === `/workspace/${workspace.id}` ||
      location.pathname.startsWith(`/workspace/${workspace.id}/`)
  );
  const requiresSignIn =
    location.pathname === '/' ||
    location.pathname === '/onboarding' ||
    isKnownWorkspace;

  if (!signedIn && !guestMode && requiresSignIn) {
    const destination = location.pathname + location.search + location.hash;
    return (
      <Navigate
        to={`/sign-in?${new URLSearchParams({ redirect_uri: destination })}`}
        replace
      />
    );
  }

  return children;
};
